import { DocumentPreview } from "@neonumy/documents-preview";
import { IoClose } from "react-icons/io5";

interface PreviewDocumentProps {
  previewDocumentUrl: string;
  onClickGoBack?: () => void;
  onClose?: () => void;
  downloadFilename?: string;
  loading?: boolean;
}

export default function DocumentViewer({
  previewDocumentUrl,
  onClickGoBack,
  onClose,
  downloadFilename,
  loading,
}: PreviewDocumentProps) {
  const viewer = (
    <DocumentPreview
      defaultZoom={130}
      thumbnails={false}
      wheelZoom={true}
      fileUrl={previewDocumentUrl}
      isPDF={true}
      onClickGoBack={onClickGoBack}
      downloadFilename={downloadFilename}
      loading={loading}
    />
  );

  if (!onClose) return viewer;

  return (
    <div className="document-viewer-with-close">
      <button type="button" className="document-viewer-close" aria-label="Close" onClick={onClose}>
        <IoClose />
      </button>
      {viewer}
    </div>
  );
}
